
export const SECURITY_OPTIONS = [
  { value: "property", label: "Property" },
  { value: "machinery", label: "Machinery" },
  { value: "fd_or_debt_mf", label: "FD or Debt MF" },
  { value: "not_available", label: "Not available" },
  { value: "other", label: "Other" },
];

export const PROFESSION_OPTIONS = [
  { value: 'salaried', label: 'Salaried' },
  { value: 'self_employed', label: 'Self Employed' },
  { value: 'business_owner', label: 'Business Owner' },
  { value: 'professional', label: 'Professional' },
  { value: 'other', label: 'Other' }
];

export const FUND_REQUIREMENT_OPTIONS = [
  { value: '1_5L', label: '1-5 Lakhs' },
  { value: '5_10L', label: '5-10 Lakhs' },
  { value: '10_25L', label: '10-25 Lakhs' },
  { value: '25_50L', label: '25-50 Lakhs' },
  { value: 'above_50L', label: 'Above 50 Lakhs' }
];

export const END_USE_OPTIONS = [
  { value: 'business_expansion', label: 'Business Expansion' },
  { value: 'working_capital', label: 'Working Capital' },
  { value: 'equipment_purchase', label: 'Equipment Purchase' },
  { value: 'debt_consolidation', label: 'Debt Consolidation' },
  { value: 'other', label: 'Other' }
];

export const assetPath = (relativePath = '') => {
  const base = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');
  const path = String(relativePath || '').replace(/^\/+/, '');
  return base ? (path ? `${base}/${path}` : base) : `/${path}`;
};

export const USER_TYPES = {
  BORROWER: 'borrower',
  LENDER: 'lender'
};

export const BORROWER_TYPES = {
  INDIVIDUAL: 'individual',
  ENTITY: 'entity'
};

export const HIDE_INDIVIDUAL_BORROWER_OPTION = String(
  process.env.REACT_APP_HIDE_INDIVIDUAL_BORROWER_OPTION ?? "true"
).toLowerCase() === "true";

export const ENTITY_TYPES = {
  COMPANY: 'company',
  PARTNERSHIP_FIRM: 'partnership_firm',
  PROPRIETORSHIP_FIRM: 'propreitorship_firm'
};